defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ClubFaq',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Faq/FaqComponent'
  ],
  function (Component, FaqComponent) {

    // Component:
    Component('club-faq', function (m, route, settings) {

      // Components:
      const root = {
        controller: function () {
          this.title = settings.faqTitle;
          this.faqItems = settings.faqItems;
        },
        view: function (controller) {
          return m('.play-together-faq__wrapper',
            m('.play-together-faq__wrapper-inner', [
              m('.play-together-faq__title', controller.title),
              m(FaqComponent, { controller })
            ])
          );
        }
      };

      // Routes:
      route('/', root);
    });

  });
